/* eslint-disable no-unused-vars  */
/* eslint-disable consistent-return */
import {browserHistory} from 'react-router';
import Ajax from 'Ajax';
import commonAction from 'Actions/common';
import {getCookie, removeCookie} from 'Utils'
import {message} from 'antd';

const middlewareConfig = {
  // 请求出错时返回Promise reject
  returnRejectedPromiseOnError: true,
  // 拦截器
  interceptors: {
    request: [
      {
        // 处理成功请求
        success: ({getState, dispatch, getSourceAction}, config) => {
          const user = window.localStorage.getItem('user') || '{}';
          const authorization = user && JSON.parse(user)?.access_token || getCookie('ekt_access_token');

          // 在每次请求前添加cancelKey,cancel请求
          config.reqId = new Date().getTime();
          config.cancelToken = Ajax.addRequest(config.reqId);
          config.headers.Authorization = `Bearer ${authorization}`;

          // if (process.env.JS_ENV === 'development') {
          //   config.headers.DEBUG = 'DEBUG';
          // }

          // dispatch(commonAction.optLoading('正在操作'));
          // 如果是jsonp，则设置适配器来处理请求
          if (config.jsonp) {
            config.adapter = config => {
              return Ajax.jsonp(config);
            };
          }

          return config;
        },
        // 处理失败请求
        error: ({getState, dispatch, getSourceAction}, error) => {
          return Promise.reject(error);
        },
      },
    ],
    response: [
      {
        // 处理成功返回
        success: ({getState, dispatch, getSourceAction}, res) => {
          const {data, data: {code} = {}} = res || {};
          // 设置拦截器，当返回401，则推出登陆，跳转到登陆页
          if (parseInt(code, 10) === 401) {
            window.localStorage.setItem('user', '');

            removeCookie('ekt_access_token')
            browserHistory.push('/oauth');

          } else {
            // 请求完成,移除cencel栈
            Ajax.removeRequest(res.config.reqId);
            // 判断服务端返回状态是否正确
            const isSuccess =
              parseInt(code, 10) === 200 || parseInt(code, 10) === 0;
            if (!isSuccess) {
              // 如果错误  需要
              if (parseInt(code, 10) === 5002) {
                message.error(data.data || data.msg);
                dispatch(commonAction.optError(data.data || data.msg));
              } else {
                if(data.msg || data.message){
                  message.error(data.msg || data.message);
                }
                dispatch(commonAction.optError(data.msg || data.message));
              }
            }
            if(res.config.responseType=="blob"){ //如果是返回的二进制文件需要完整信息
              return res
            }else{
              return data;
            }
          }
        },
        // 处理失败返回
        error: ({getState, dispatch, getSourceAction}, error) => {
          // 取消操作错误不发出
          if (Ajax.axios.isCancel(error)) {
          } else {
            // dispatch(commonAction.optError('网络异常'));
            return Promise.reject(error);
          }
        },
      },
    ],
  },
};

export default middlewareConfig;
